import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Popconfirm,
  Button,
  message,
  Typography,
} from 'antd';

const { Title } = Typography;

class DeleteUser extends PureComponent {
  success = (msg) => {
    message.success(msg);
  };

  handleDelete = () => {
    this.props.deleteProfile(() => {
      this.success('Account has been deleted');
    });
  };

  render() {
    return (
      <div>
        <Title level={4}>Delete User Account</Title>
        <br/>
        <Popconfirm
          title="Are you sure delete this user data?"
          okText="Yes"
          cancelText="No"
          onConfirm={this.handleDelete}
        >
          <Button
            type="danger"
            size="large"
            ghost
          >
            Delete
          </Button>
        </Popconfirm>
      </div>
    );
  }
}

DeleteUser.propTypes = {
  deleteProfile: PropTypes.func.isRequired,
};

export default DeleteUser;
